module.exports = __webpack_public_path__ + "static/media/Collaborate with.41ec35fa.webp";